import Hero from "../Component/Hero";
import DownloadAppSection from "../../../Components/DownloadAppSection";
import AlurPeminjaman from "../Component/AlurPeminjaman";
import KeuntunganBermitra from "../Component/KeuntunganBermitra";
import AllProductIndividu from "../Component/AllProductIndividu";

function PinjamanIndividu() {
    return (
        <>
            <div>
                <Hero
                    imageClass='ebp'
                    title='Pinjaman Karyawan'
                    subTitle='P I N J A M A N &emsp;I N D I V I D U'
                    explanation='
                        Fasilitas Ini ditujukan kepada perusahaan-perusahaan yang mempunyai kendala <em>Cash
                        Flow</em> ketika ingin memiliki program kesejahteraan bagi karyawannya <b>(<em>Employee Benefit Program</em>).</b>
                        <br/><br/>
                        Dengan bermitra dengan Danai.id, maka perusahaan kecil atau yang sedang berkembang dapat
                        memiliki program/ fasilitas kesejahteraan bagi karyawannya.
                        Keuntungan lain bagi perusahaan jika memiliki fasilitas ini adalah dapat meningkatkan daya saing
                        perusahaan dalam merekrut &amp; mempertahankan
                        karyawan-karyawan terbaiknya'
                />
                <KeuntunganBermitra/>
                <AllProductIndividu/>
                <AlurPeminjaman type='individu'/>
                <DownloadAppSection/>
            </div>
        </>
    );
}

export default PinjamanIndividu;
